import PropTypes from "prop-types";
import { useState, useEffect } from "react";
import { Box, FormControlLabel, Checkbox } from "@mui/material";

function CheckboxField({ displayName, fieldRef, options }) {
  const [isChecked, setIsChecked] = useState(false);
  // console.log(options);
  useEffect(() => {
    if (isChecked === null) {
      return;
    }

    const watchField = document.getElementById(`dff_${fieldRef}`);
    watchField.dispatchEvent(new Event("change"));
  }, [isChecked]);

  return (
    <Box>
      <FormControlLabel
        control={
          <Checkbox
            checked={isChecked}
            onChange={(e) => setIsChecked(e.target.checked)}
          />
        }
        label={displayName}
      />
      <input
        type="hidden"
        id={`dff_${fieldRef}`}
        name={fieldRef}
        value={isChecked ? "yes" : "no"}
      />
    </Box>
  );
}

// Typechecking props of the Transaction
CheckboxField.propTypes = {
  fieldRef: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.any),
};

CheckboxField.defaultProps = {
  options: null,
};

export default CheckboxField;
